import CalendarWrapper from '@v/components/CalendarWrapper.vue';
import { createVueApp } from '@v/utils/createVueApp';
import { useCalendar } from '@v/composables/useCalendar';
import { getUrlVars, qsa } from '@js/utils/toolbox';

const { sorting, setFilters, updateCheapestDays, queueNearbyDates } = useCalendar();

function updateSortingInput (newSorting) {
	qsa(`div.priceCalendarSorting input[value="${newSorting}"]`).forEach((input) => {
		input.checked = true;
	});
}
export class PriceCalendarOnWay {
	constructor (nearbyDates) {
		this.nearbyDates = nearbyDates;
		this.isOpen = false;
		this.component = null;
	}

	setFilters () {
		setFilters();
	}

	setSorting (newSorting) {
		sorting.value = newSorting;

		updateSortingInput(newSorting);
		updateCheapestDays();
	}

	close () {

	}

	open () {
		this.isOpen = true;
		if (!this.component) {
			this.component = createVueApp(CalendarWrapper, {
				autoSearch: this.nearbyDates === true || getUrlVars().forceNearbyDates
			}).mount('.priceCalendar__inner');
			updateSortingInput(sorting.value);
		}
	}
}
